var map = {
	"./Banner-AlcoholLiquido.jpg": 57,
	"./Banner-QuatOne10.jpg": 58,
	"./Banner-SabonMed.jpg": 59,
	"./Banner-SavonDog.jpg": 60,
	"./Banner-Synthetical.jpg": 61,
	"./SLIDERS-BIO-600.png": 62,
	"./SLIDERS-COVID2-600.png": 63,
	"./SLIDERS-CR-600.png": 64,
	"./SLIDERS-EXP-600.png": 65,
	"./SLIDERS-PD-600.png": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;